import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import axios from 'axios';

function FormularioDefinicionServicioBen() {
	const navigate = useNavigate();

	const defaultValues = {
		preg1: "",
		preg2: "",
		preg3: "",
		preg4: ""
	};

	const [sendingForm, setSendingForm] = useState({});

	const { register, handleSubmit, formState: { errors }, setValue } = useForm({
		initialValues: defaultValues
	})

	const handleChange = (e) => {
		let sessionData = JSON.parse(sessionStorage.getItem("Empleado-Info"));

		const { name, value } = e.target;
		// console.log(name, value);
		// console.log(sendingForm, "sendingForm");
		let data = sessionData;

		if (data.conocimiento_beneficio === undefined) {
			data.conocimiento_beneficio = defaultValues;	
		}

		if (name === "preg1") {
			data.conocimiento_beneficio.preg1 = value;
		} else if (name === "preg2") {
			data.conocimiento_beneficio.preg2 = value;
		} else if (name === "preg3") {
			data.conocimiento_beneficio.preg3 = value;
		} else if (name === "preg4") {
			data.conocimiento_beneficio.preg4 = value;
		}
		
		sessionStorage.setItem("Empleado-Info", JSON.stringify(data));
		setSendingForm(data);
	};

	async function sendData(e) {
		let form = JSON.parse(sessionStorage.getItem("Empleado-Info"))
		form.conocimiento_beneficio = e;

		sessionStorage.setItem("Empleado-Info", JSON.stringify(form))

		let uri = process.env.REACT_APP_API_URL + 'formularios';

		let config = {
			headers: {
				'Content-Type': 'multipart/form-data',
				'Accept': 'application/json'
			}
		};

		try {
			let response = await axios({
				method: 'POST',
				url: uri,
				data: form,
				headers: config.headers
			});
			console.log(response);
			Swal.fire(
				{
					title: 'Registro exitoso',
					text: 'Datos enviados correctamente',
					icon: 'success',
					confirmButtonText: 'Aceptar'
				}
			)
				.then(function () {
					sessionStorage.removeItem("Empleado-Info");
					navigate("/Beneficiario")
				})
		} catch (error) {
			console.log(error);
		}
	}

	const getData = () => {
		if (sessionStorage.getItem("Empleado-Info") !== null) {
			let data = JSON.parse(sessionStorage.getItem("Empleado-Info"));
			console.log(data, "sessionStorage");
			
			if (!data.conocimiento_beneficio) {
				console.log("No hay datos");
				data.conocimiento_beneficio = defaultValues;
			}

			setValue("preg1", data.conocimiento_beneficio.preg1);
			setValue("preg2", data.conocimiento_beneficio.preg2);
			setValue("preg3", data.conocimiento_beneficio.preg3);
			setValue("preg4", data.conocimiento_beneficio.preg4);	

			setSendingForm(data);

			
			return;
		}

		navigate("/Beneficiario_DatosTrabajador")
		return;
	};

	const loadData = () => {
		getData();
	};

	useEffect(() => {
		let sessionData = JSON.parse(sessionStorage.getItem("Empleado-Info"));
		
		if (sessionData?.conocimiento_beneficio !== sendingForm) {
			loadData();
		}
	}, []);

	return (
		<div className="mt-14 w-auto px-6">
			<h1 className="text-3xl font-bold text-[#0D7F9F]">Definicion del Servicio</h1>
			<p className='text-md my-2'> Un Centro de Atención a Primera Infancia (CAPI), es un establecimiento destinado a implementar la vía institucional del modelo de atención integral a la Primera Infancia y a promover un cuidado cariñoso y sensible, estimulación oportuna y educación de calidad, con el propósito de favorecer el desarrollo físico, cognitivo, afectivo y social de las niñas y niños. </p>
			<form className="flex flex-col w-auto text-lg" onSubmit={handleSubmit(sendData)}>
				<div className="flex flex-col justify-between w-auto p-4 border rounded-lg mb-2 bg-[#D1ECF2]">
					<div className='flex flex-row justify-between'>
						<label htmlFor='preg1' className='font-semibold'>¿Estas interesado en usar el beneficio CAPI que ofrecerá tu empresa?</label>
						<div className="flex justify-between w-[100px]">
							<label>
								<input type="radio" value="Si" {...register("preg1", { required: "Elige una respuesta" })}
									defaultValue={sendingForm?.conocimiento_beneficio?.preg1}
									// checked={sendingForm?.conocimiento_beneficio?.preg1 === "Si"}
									// defaultChecked={sendingForm?.conocimiento_beneficio?.preg1 === "Si"}
									onChange={(e) => handleChange(e)}
								/>Si
							</label>
							<label>
								<input type="radio" value="No" {...register("preg1", { required: "Elige una respuesta" })}
									defaultValue={sendingForm?.conocimiento_beneficio?.preg1}
									onChange={(e) => handleChange(e)}
								/>
								No
							</label>
						</div>
					</div>
				</div>
				{errors.preg1 && <span className='text-red-600 w-full px-2 flex justify-end'>{errors.preg1.message}</span>}
				<div className="mr-2 w-full flex flex-row justify-between items-center p-2 border rounded-lg mb-2 bg-[#D1ECF2]">
					<label htmlFor='preg2' className="p-1 w-3/4 font-semibold">Si te ofrecen el servicio CAPI, donde preferirías utilizar el servicio: (opcional)</label>
					<select className="w-1/4 border-2 p-4 h-2/3 text-lg font-normal bg-white rounded-lg" {...register("preg2")}
						defaultValue={sendingForm?.conocimiento_beneficio?.preg2}
						onChange={(e) => handleChange(e)}
					>
						<option value="">Donde prefieres utilizarlo</option>
						<option value="Cerca de Residencia">Cerca de la residencia de tu hijo</option>
						<option value="Cerca de Trabajo">Cerca de tu centro de trabajo</option>
						<option value="Cerca de Lugar de Cuido">Cerca del lugar de cuido de tu hijo</option>
					</select>
				</div>
				<div htmlFor="preg3" className="mr-2 w-full flex flex-row justify-between items-center p-2 border rounded-lg mb-2 bg-[#D1ECF2]">
					<label className="p-1 w-3/4 font-semibold">De utilizar el servicio de Centro de Atención a la Primera infancia (CAPI), ¿Quién llevaría a tu hijo(a) a las instalaciones de éste?</label>
					<select className="w-1/4 border-2 p-4 h-2/3 text-lg font-normal bg-white rounded-lg" {...register("preg3")}
						defaultValue={sendingForm?.conocimiento_beneficio?.preg3}
						onChange={(e) => handleChange(e)}
					>
						<option value="">¿Quíen lo llevaría?</option>
						<option value="yo">Yo</option>
						<option value="conyugue">Cónyuge</option>
						<option value="abuelos">Abuelos</option>
						<option value="otro">Otro familiar</option>
					</select>
				</div>
				<div className="mr-2 w-full flex flex-row justify-between items-center p-2 border rounded-lg mb-2 bg-[#D1ECF2]">
					<label htmlFor='preg4' className="p-1 w-3/4 font-semibold">De utilizar en la actualidad una guardería, ¿Cuál es el nombre de la guardería / kínder / establecimiento?  </label>
					<input id="" placeholder="Nombre del establecimiento" className="w-1/4 border-2 p-4 text-lg h-2/3 bg-white rounded-lg font-normal" type="text" {...register("preg4")}
						defaultValue={sendingForm?.conocimiento_beneficio?.preg4}
						onChange={(e) => handleChange(e)}
					/>
				</div>
				<div className="flex justify-end mt-4">
					<div className='w-[180px] justify-between flex flex-row'>
						<Link to="/Beneficiario_DatosHijos" data-discover="true">
							<button className="bg-white border-4 border-[#0E7FA0] font-medium drop-shadow-2xl shadow-2xl text-white w-full rounded-full w-[50px] h-[50px] p-[12px]"><FontAwesomeIcon icon={faArrowLeft} className='text-[#0E7FA0] text-lg' /></button>
						</Link>
						<button className="bg-[#99C33E] font-medium drop-shadow-2xl shadow-2xl text-white rounded-full w-[120px] h-[50px] p-[12px]" type='submit'>Enviar</button>
					</div>
				</div>
			</form>
		</div>
	)
}

export default FormularioDefinicionServicioBen;